import { useTranslation } from 'react-i18next'

const FILTER_KEYS = ['all', 'open', 'cert', 'upcoming', 'expired']

export default function ExamFilters({ active = 'all', onChange, counts = {} }) {
  const { t } = useTranslation()

  const labels = {
    all:      t('exams.filterAll',      'Hammasi'),
    open:     t('exams.filterOpen',     'Boshlash mumkin'),
    cert:     t('exams.filterCert',     'Sertifikatli'),
    upcoming: t('exams.filterUpcoming', 'Tez ochiladi'),
    expired:  t('exams.filterExpired',  'Yakunlangan'),
  }

  return (
    <div
      className="flex gap-2 overflow-x-auto pb-2"
      style={{ scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}
    >
      {FILTER_KEYS.map((key) => {
        const isActive = active === key
        return (
          <button
            key={key}
            onClick={() => onChange?.(key)}
            className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-[13px] border transition-all whitespace-nowrap flex-shrink-0 font-medium"
            style={
              isActive
                ? { background: 'var(--coral)', color: '#fff', borderColor: 'var(--coral)' }
                : { background: 'var(--surface)', color: 'var(--ink-2)', borderColor: 'var(--border)' }
            }
            onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'var(--bg-soft)' }}
            onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'var(--surface)' }}
          >
            {labels[key]}
            {counts[key] != null && (
              <span className="font-mono text-[11px] opacity-60">{counts[key]}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
